module.exports = __webpack_public_path__ + "img/2.0336025e.png";